import { ImageSize } from '@/hotdesk-ui/helpers/image-url';

/**
 * Photo size variant per `ListingCard` layout, split by viewport so phones
 * download a smaller file than desktops. Tied to each layout's CSS width:
 * update these when a card's width changes.
 */
export type CardLayout = 'grid' | 'compact' | 'minimal' | 'explore';
export type CardImageSizes = { mobile: ImageSize; desktop: ImageSize };

/** Matches CarouselSection's mobile breakpoint. */
export const CARD_IMAGE_MOBILE_MEDIA = '(max-width: 640px)';

// Keeps photos sharp on 3x phones: `sm` (~480px) only where the card is
// ~160px wide on a phone (landing carousels, 2.2 per row). Detail-page
// carousels (~310px) and the explore grid (full width, ~343px) need `md`.
export const CARD_IMAGE_SIZES: Record<CardLayout, CardImageSizes> = {
    minimal: { mobile: 'sm', desktop: 'md' },
    grid: { mobile: 'md', desktop: 'md' },
    explore: { mobile: 'md', desktop: 'md' },
    compact: { mobile: 'md', desktop: 'md' }
};
